<div class="chart-cntainer">
    @if (chartData()) {
      <p-chart type="bar" 
      [data]="chartData()" 
      [options]="chartOptions"
      style="width: 100%; max-width: 500px;" />
  } @else {
    <p>Nessun dato disponibile per il grafico.</p>
  }
</div>